module.exports = __webpack_public_path__ + "img/jdoodle-fb.7ced2116.png";